import { Granularity } from "@/API";
import { IStat, Stat } from "@/entities";
import { ISaleStatRepository } from "@/repositories";
import { ISaleStatService } from ".";
import dayjs from "dayjs";

export class SaleStatService implements ISaleStatService {
    constructor(private repository: ISaleStatRepository) { }

    async listDailyStat(id: string, from?: Date, to?: Date): Promise<Stat[] | undefined> {
        let token: string | undefined;
        let param = {};
        let list: Stat[] = [];

        if (from && to) {
            const fromDate = dayjs(from)
            const toDate = dayjs(to)
            // console.log(fromDate,toDate,fromDate.unix(), toDate.unix());
            param = {
                between: [{ granularity: Granularity.DAILY, timestamp: fromDate.unix() }, { granularity: Granularity.DAILY, timestamp: toDate.unix() }]
            }
            console.log("listDailyStat with filter", param);
        }

        do {
            const { items, nextToken } = await this.repository.getSaleStat(id, param, token)
            // console.log(items, nextToken);
            if (items) {
                const l = items.map((i: any) => new Stat(i));
                list = [...list, ...l];
            }
            token = nextToken;
        }
        while (token);

        // console.log(list);
        return list;
    }

    async listWeeklyStat(id: string, from?: Date, to?: Date): Promise<Stat[] | undefined> {
        let token: string | undefined;
        let param = {};
        let list: Stat[] = [];

        if (from && to) {
            const fromDate = dayjs(from).startOf("week");
            const toDate = dayjs(to).endOf("week");
            // console.log(fromDate,toDate,fromDate.unix(), toDate.unix());
            param = {
                between: [{ granularity: Granularity.WEEKLY, timestamp: fromDate.unix() }, { granularity: Granularity.WEEKLY, timestamp: toDate.unix() }]
            }
            console.log("listWeeklyStat with filter", param);
        }

        do {
            const { items, nextToken } = await this.repository.getSaleStat(id, param, token)
            // console.log(items, nextToken);
            if (items) {
                const l = items.map((i: any) => new Stat(i));
                list = [...list, ...l];
            }
            token = nextToken;
        }
        while (token);

        // console.log(list);
        return list;
    }
    async listMonthlyStat(id: string, from?: Date, to?: Date): Promise<Stat[] | undefined> {
        let token: string | undefined;
        let param = {};
        let list: Stat[] = [];

        if (from && to) {
            const fromDate = dayjs(from).startOf('month');
            const toDate = dayjs(to).endOf('month');
            // console.log(fromDate,toDate,fromDate.unix(), toDate.unix());
            param = {
                between: [{ granularity: Granularity.MONTHLY, timestamp: fromDate.unix() }, { granularity: Granularity.MONTHLY, timestamp: toDate.unix() }]
            }
            console.log("listMonthlyStat with filter", param);
        }

        do {
            const { items, nextToken } = await this.repository.getSaleStat(id, param, token)
            // console.log(items, nextToken);
            if (items) {
                const l = items.map((i: any) => new Stat(i));
                list = [...list, ...l];
            }
            token = nextToken;
        }
        while (token);

        // console.log(list);
        return list;
    }

}